import { useAccount } from './useAccount';

export const useCurrentOrgZuoraAccountCreated = () => {
  const accountQuery = useAccount();
  if (accountQuery.isSuccess) {
    return {
      ...accountQuery,
      data: !!accountQuery.data.currentOrganization.zAccountId
    };
  } else {
    // Return account query status if data is not yet fetched
    return {
      ...accountQuery,
      data: undefined
    };
  }
};
